import React from 'react';
import moment from 'moment';
import { startCase } from 'lodash';
import { object } from 'yup';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';
import FormResource from './FormResource.jsx';

const defaults = {
  poNo: '',
  lineNo: 0,
  erpId: 0,
  status: '',
  productionStatus: '',
  quantity: 0,
  quantityUnit: '',
  soNo: '',
  itemCode: '',
  rawDesign: '',
  rawColl: '',
  material: '',
  size: '',
  color: '',
  quality: '',
  brand: '',
  construction: '',
  exMillDate: '',
  transfer: {
    price: 0,
    currency: '',
  },
  retail: {
    price: 0,
    currency: '',
  },
  photos: [],
  artworks: [],
};

const schema = object({});

const FormStock = ({ prestock }) => {
  const api = '/api/core/pre-stocks';
  const canEdit = prestock?.status === 'open'
    && prestock?.productionStatus === 'ReadyToShip';

  return (
    <FormResource
      {...{
        defaults,
        schema,
        formStatus: canEdit ? {} : { disabled: true },
        stored: prestock
          ? {
            ...prestock,
            exMillDate: prestock.exMillDate
              ? moment(prestock.exMillDate).format(
                env.f.d,
              )
              : '',
          }
          : undefined,
        api,
      }}>
      <div className="row">
        <div className="col">
          <FormGroup
            label="PO Number"
            name="poNo"
            disabled
          />
        </div>
        <div className="col">
          <FormGroup
            name="lineNo"
            label="Line Number"
            disabled
          />
        </div>
        <div className="col">
          <FormGroup name="erpId" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="status" disabled />
        </div>
        <div className="col">
          <FormGroup name="productionStatus" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="quantity" disabled />
        </div>
        <div className="col">
          <FormGroup name="quantityUnit" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup
            name="soNo"
            label="Sales Order Number"
            disabled
          />
        </div>
        <div className="col">
          <FormGroup name="itemCode" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup
            name="rawDesign"
            label="Design"
            disabled
          />
        </div>
        <div className="col">
          <FormGroup
            name="rawColl"
            label="Collection"
            disabled
          />
        </div>
        <div className="col">
          <FormGroup name="material" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="size" disabled />
        </div>
        <div className="col">
          <FormGroup name="color" disabled />
        </div>
        <div className="col">
          <FormGroup name="construction" disabled />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup name="quality" disabled />
        </div>
        <div className="col">
          <FormGroup name="brand" disabled />
        </div>
        <div className="col">
          <FormGroup name="exMillDate" disabled />
        </div>
      </div>
      {canEdit && (
        <>
          <div className="row">
            <div className="col">
              <FormGroup
                name="transfer.price"
                type="number"
              />
            </div>
            <div className="col">
              <FormGroup
                name="transfer.currency"
                as="select">
                <option value=""> - </option>
                {env.currencies.map(({ code, symbol }) => (
                  <option value={code} key={code}>
                    {`${startCase(code)} - ${symbol}`}
                  </option>
                ))}
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormGroup
                name="retail.price"
                type="number"
              />
            </div>
            <div className="col">
              <FormGroup name="retail.currency" as="select">
                <option value=""> - </option>
                {env.currencies.map(({ code, symbol }) => (
                  <option value={code} key={code}>
                    {`${startCase(code)} - ${symbol}`}
                  </option>
                ))}
              </FormGroup>
            </div>
          </div>

          <FormGroup
            name="photos"
            as="slider"
            api="/api/core/stocks/files"
            label="Photos"
            gridClassName="col-3 my-3"
            slideClassName="file-slide-contain square"
          />
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
            ARTWORK
          </h6>
          <FormGroup
            name="artworks"
            as="objSlider"
            api="/api/core/stocks/files"
            label="Artwork"
            fileOpts={{
              accept:
                'application/pdf, image/jpeg, image/png',
            }}
            gridClassName="col-3 my-3"
            slideClassName="file-slide-contain square"
            childKey="url"
            defaultChild={(f) => ({
              url: f,
              title: f.name,
            })}>
            {({ i }) => (
              <FormGroup
                name={`artworks.${i}.title`}
                label={`File ${i + 1}`}
              />
            )}
          </FormGroup>
        </>
      )}
    </FormResource>
  );
};

export default FormStock;
